import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStore, CustomerAccount } from '../context/StoreContext';
import { Package, User, MapPin, LogOut, ChevronRight, FileText } from 'lucide-react';
import { STATUS_META } from '../data/adminMockData';
export function Account() {
  const {
    currentUser,
    login,
    logout,
    orders,
    addCustomer
  } = useStore();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleAuth = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (isLogin) {
      if (email) {
        login(email);
      }
    } else {
      if (password !== confirmPassword) {
        setError('Passwords do not match');
        return;
      }
      if (email && firstName && lastName) {
        addCustomer({
          id: `CUST-${Math.floor(Math.random() * 10000)}`,
          firstName,
          lastName,
          email,
          phone,
          addresses: []
        });
        login(email);
      }
    }
  };
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  if (!currentUser) {
    return <div className="bg-gray-50 min-h-[70vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-317">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-gray-200 p-8" data-id="element-318">
          <div className="text-center mb-8" data-id="element-319">
            <h2 className="text-3xl font-extrabold text-yarbo-dark" data-id="element-320">
              {isLogin ? 'Welcome Back' : 'Create Account'}
            </h2>
            <p className="text-gray-600 mt-2" data-id="element-321">
              {isLogin ? 'Sign in to your Merem Robotics account' : 'Join Merem Robotics today'}
            </p>
          </div>

          <form onSubmit={handleAuth} className="space-y-4" data-id="element-322">
            {!isLogin && <div className="grid grid-cols-2 gap-4" data-id="element-323">
                <div data-id="element-324">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-325">
                    First Name
                  </label>
                  <input type="text" required value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-326" />
                </div>
                <div data-id="element-327">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-328">
                    Last Name
                  </label>
                  <input type="text" required value={lastName} onChange={e => setLastName(e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-329" />
                </div>
              </div>}

            <div data-id="element-330">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-331">
                Email Address
              </label>
              <input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" placeholder="info@meremrobotics.com" data-id="element-332" />
            </div>

            {!isLogin && <div data-id="element-333">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-334">
                  Phone Number (Optional)
                </label>
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-335" />
              </div>}

            <div data-id="element-336">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-337">
                Password
              </label>
              <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-338" />
            </div>

            {!isLogin && <div data-id="element-339">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-340">
                  Confirm Password
                </label>
                <input type="password" required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-341" />
              </div>}

            {error && <p className="text-red-600 text-sm" data-id="element-342">{error}</p>}

            <button type="submit" className="w-full bg-yarbo-dark text-white font-bold py-3 rounded-lg hover:bg-black transition-colors mt-6" data-id="element-343">
              {isLogin ? 'Sign In' : 'Create Account'}
            </button>
          </form>

          <div className="mt-6 text-center" data-id="element-344">
            <button onClick={() => {
            setIsLogin(!isLogin);
            setError('');
          }} className="text-sm font-bold text-yarbo-dark hover:underline" data-id="element-345">
              {isLogin ? "Don't have an account? Sign up" : 'Already have an account? Sign in'}
            </button>
          </div>
        </div>
      </div>;
  }
  const userOrders = orders.filter(o => o.customer.email.toLowerCase() === currentUser.email.toLowerCase());
  return <div className="bg-gray-50 min-h-screen py-12" data-id="element-346">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-347">
        <div className="flex flex-col md:flex-row gap-8" data-id="element-348">
          {/* Sidebar */}
          <aside className="md:w-64 flex-shrink-0" data-id="element-349">
            <div className="bg-white rounded-2xl border border-gray-200 p-6 sticky top-24" data-id="element-350">
              <div className="flex items-center gap-4 mb-8" data-id="element-351">
                <div className="w-12 h-12 bg-yarbo-yellow rounded-full flex items-center justify-center text-yarbo-dark font-bold text-xl" data-id="element-352">
                  {currentUser.firstName.charAt(0)}
                  {currentUser.lastName.charAt(0)}
                </div>
                <div data-id="element-353">
                  <h2 className="font-bold text-yarbo-dark" data-id="element-354">
                    {currentUser.firstName} {currentUser.lastName}
                  </h2>
                  <p className="text-xs text-gray-500 truncate" data-id="element-355">
                    {currentUser.email}
                  </p>
                </div>
              </div>

              <nav className="space-y-2" data-id="element-356">
                <button className="w-full flex items-center gap-3 px-4 py-2.5 bg-gray-100 text-yarbo-dark font-bold rounded-lg" data-id="element-357">
                  <Package className="w-4 h-4" data-id="element-358" /> Order History
                </button>
                <button className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-600 hover:bg-gray-50 font-medium rounded-lg transition-colors" data-id="element-359">
                  <User className="w-4 h-4" data-id="element-360" /> Profile Info
                </button>
                <button className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-600 hover:bg-gray-50 font-medium rounded-lg transition-colors" data-id="element-361">
                  <MapPin className="w-4 h-4" data-id="element-362" /> Saved Addresses
                </button>
              </nav>

              <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-363">
                <button onClick={handleLogout} className="w-full flex items-center gap-3 px-4 py-2.5 text-red-600 hover:bg-red-50 font-medium rounded-lg transition-colors" data-id="element-364">
                  <LogOut className="w-4 h-4" data-id="element-365" /> Sign Out
                </button>
              </div>
            </div>
          </aside>

          {/* Main Content */}
          <main className="flex-1" data-id="element-366">
            <h1 className="text-2xl font-extrabold text-yarbo-dark mb-6" data-id="element-367">
              Order History
            </h1>

            {userOrders.length === 0 ? <div className="bg-white rounded-2xl border border-gray-200 p-12 text-center" data-id="element-368">
                <Package className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-369" />
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-370">
                  No orders yet
                </h3>
                <p className="text-gray-500 mb-6" data-id="element-371">
                  When you place an order, it will appear here.
                </p>
                <Link to="/shop" className="inline-block bg-yarbo-dark text-white font-bold px-6 py-3 rounded-lg hover:bg-black transition-colors" data-id="element-372">
                  Start Shopping
                </Link>
              </div> : <div className="space-y-6" data-id="element-373">
                {userOrders.map(order => {
              const statusMeta = STATUS_META[order.status];
              return <div key={order.id} className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-374">
                      <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex flex-wrap items-center justify-between gap-4" data-id="element-375">
                        <div className="flex items-center gap-6" data-id="element-376">
                          <div data-id="element-377">
                            <p className="text-xs text-gray-500 uppercase tracking-wider font-bold mb-1" data-id="element-378">
                              Order Placed
                            </p>
                            <p className="text-sm font-medium text-gray-900" data-id="element-379">
                              {new Date(order.placedAt).toLocaleDateString()}
                            </p>
                          </div>
                          <div data-id="element-380">
                            <p className="text-xs text-gray-500 uppercase tracking-wider font-bold mb-1" data-id="element-381">
                              Total
                            </p>
                            <p className="text-sm font-medium text-gray-900" data-id="element-382">
                              $
                              {order.items.reduce((sum, item) => sum + item.unitPrice * item.qty + (item.protection?.price || 0), 0) + order.shippingCost + order.tax}
                            </p>
                          </div>
                          <div data-id="element-383">
                            <p className="text-xs text-gray-500 uppercase tracking-wider font-bold mb-1" data-id="element-384">
                              Order #
                            </p>
                            <p className="text-sm font-medium text-gray-900" data-id="element-385">
                              {order.id}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-4" data-id="element-386">
                          <span className={`px-3 py-1 rounded-full text-xs font-bold ${statusMeta.bg} ${statusMeta.text}`} data-id="element-387">
                            {statusMeta.label}
                          </span>
                          <button className="text-sm font-bold text-yarbo-dark hover:text-black flex items-center gap-1" data-id="element-388">
                            View Details <ChevronRight className="w-4 h-4" data-id="element-389" />
                          </button>
                        </div>
                      </div>

                      <div className="p-6" data-id="element-390">
                        <div className="space-y-4" data-id="element-391">
                          {order.items.map((item, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-392">
                              <div className="w-16 h-16 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-393">
                                <Package className="w-6 h-6 text-gray-400" data-id="element-394" />
                              </div>
                              <div className="flex-1 min-w-0" data-id="element-395">
                                <h4 className="text-sm font-bold text-gray-900" data-id="element-396">
                                  {item.productName}
                                </h4>
                                <p className="text-xs text-gray-500 mt-1" data-id="element-397">
                                  Qty: {item.qty}
                                </p>
                                {item.protection && <p className="text-xs text-yarbo-dark font-medium mt-1" data-id="element-398">
                                    + {item.protection.plan}
                                  </p>}
                              </div>
                              <div className="text-sm font-bold text-gray-900" data-id="element-399">
                                ${item.unitPrice.toLocaleString()}
                              </div>
                            </div>)}
                        </div>
                      </div>
                    </div>;
            })}
              </div>}
          </main>
        </div>
      </div>
    </div>;
}